export const selectInputOnFocus = (event: React.FocusEvent<HTMLInputElement>) => {
	if (event.currentTarget.type !== 'text') {
		event.currentTarget.focus();
		return;
	}

	const val = event.currentTarget.value;

	event.currentTarget.value = '';
	event.currentTarget.value = val;

	event.currentTarget.setSelectionRange(val.length, val.length);
	event.currentTarget.select();
};

export const textToNumber = (maybeNumber: string | null | undefined): number | undefined => {
	const asNumber = parseFloat(maybeNumber || '');

	return isNaN(asNumber) ? undefined : asNumber;
};
